import {SortDirection} from "../../../types/types";
import {Icon} from "@chakra-ui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faCaretUp} from "@fortawesome/free-solid-svg-icons";

export const SortArrow = ( {direction, isDisabled}: {direction:SortDirection, isDisabled?:boolean } ) =>
  <Icon ml={2} opacity={isDisabled ? 0.7 : 1}><FontAwesomeIcon icon={direction === "ASC" ? faCaretUp : faCaretDown }/></Icon>;